<!--
 * @Author: 金小瑞
 * @Date: 2018-07-24 08:51:44
 * @LastEditors: 金小瑞
 * @LastEditTime: 2019-08-23 14:17:41
 * @Description: '关联新建功能  通用模块'
 * @Props: 
 * @Emit: 
 -->
 <!--
  关联新建功能  通用模块
  props:
    attrValue: 默认绑定值
    customerId: 详情页id
    module 模块名
  emit:
    emitObj: 提交已选数据
 -->

<template>
  <div class="mult-select associated">
    <el-dialog :title="title+'选择'" :visible.sync="dialogVisible" :modal="modal">
      <div class="content">
        <div class="template" v-if="templateList.length > 1">
          <div class="template-box">
            <template v-for="(template, index) in templateList">
              <div class="template-item"
                v-if="templateList.length < 4 ? true : index < 2"
                :class="{'active': template.key === curTemplate.key}"  
                :key="template.key"
                @click="toggleTemplate(template, 'click')">
                <span>{{template.value}}</span>
              </div>
              <el-dropdown
                v-else-if="index===3"
                :key="template.key"
                @command="toggleTemplate">
                <div class="template-item"
                  :class="{'active': foldTemplate.key === curTemplate.key}"  
                  >
                  <span>{{foldTemplate.value}}</span>
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item 
                    :command="template"
                    v-for="template in foldTemplateList"
                    :key="template.key"
                    >{{template.value}}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template> 
          </div>
        </div>
        <div class="search">
          <div class="search-left">
            <el-select
              v-if="groups.length"
              class="manager"
              v-model="group"
              size="small"
              @change="getUserList('group')">
              <el-option
                v-for="option in groups"
                :key="option.key"
                :label="option.value"
                :value="option.key">
              </el-option>
            </el-select>
            <el-input size="small" class="input" prefix-icon="el-icon-search" v-model="contactSearch" @change="handleSearch" :placeholder="placeholderStr">
            </el-input>
          </div>
          <el-button type="text" icon="el-icon-plus" @click="addNew">{{'新建'+title}}</el-button>
        </div>
        <div class="select-list">
          <el-table
            ref="table"
            :data="userList"
            max-height="370"
            v-loading.body="loading"
            row-key="id"
            border
            @select="handleSelect"
            >
            <el-table-column
              type="selection"
              width="50"
            >
            </el-table-column>
            <el-table-column
              v-for="header in headerArray"
              :key="header.attr"
              :prop="header.attr"
              :label="header.attrName">
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <div v-if="multiselect" class="select-length">已选 {{idArr.length}} 个</div>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from 'src/api'
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
let lazy
const dataMap = {
  customerApi: '/customerApi/getCustomers.html',
  contactApi: '/contactApi/getContacts.html',
  contractApi: '/contractApi/getContractList.html',
  supplier: '/supplier/getSupplierList.html',
  purchase: '/purchase/getPurchaseList.html',
  opportunityApi: '/opportunityApi/getOpportunitys.html'
}
const dataGroups = {
  customerApi: '/customerApi/getCustomerGroups.html',
  contractApi: '/contractApi/getContractGroups.html',
  supplier: '/supplier/getSupplierGroups.html',
  purchase: '/purchase/getPurchaseGroups.html',
  opportunityApi: '/opportunityApi/getOpportunityGroups.html'
}
const placeholderMap = {
  customerApi: '客户姓名或电话搜索',
  contactApi: '姓名或电话搜索',
  contractApi: '合同名称或编号搜索',
  supplier: '供应商名称搜索',
  purchase: '采购单编号搜索',
  opportunityApi: '机会名称或编号搜索'
}
export default {
  created () {
    if (this.multiselect) {
      this.selectArr[0] = JSON.parse(JSON.stringify(this.attrValue)) || []
    }
    this.selectContacts = JSON.parse(JSON.stringify(this.attrValue)) || []
    if (this.module === 'customerApi' || this.module === 'contractApi') {
      this.getTemplateList()
    } else {
      this.getUserList()
      this.getGroups()
    }
    this.placeholderStr = placeholderMap[this.module]
  },
  props: {
    attrValue: {
      type: Array,
      default: () => []
    },
    // 关联的客户ID
    customerId: {
      default: 0
    },
    // 对应的模块
    module: {
      Type: String,
      default: 'customerApi'
    },
    modal: {
      type: Boolean,
      default: false
    },
    supplierId: {
      type: Number,
      default: 0
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    fromMoudle: {
      type: String,
      default: ''
    },
    item: {
      type: Object
    }
  },
  data () {
    return {
      contactSearch: '',
      userList: [],
      selectContacts: [],
      selectClass: false,
      // 分页信息
      currentPage: 1,
      total: 0,
      dialogVisible: false,
      pageSize: 12,
      loading: false,
      groups: [],
      group: '0',
      headerArray: [],
      selectArr: [], // 多选时用来存放每一页的选项的
      templateList: [], // 模板列表
      curTemplate: '', // 当前模板
      foldTemplate: {}, // 折叠时显示的模板
      foldTemplateList: [] // 折叠的模板列表
    }
  },
  computed: {
    ...mapGetters([
      'moduleName'
    ]),
    // 包含已选产品id的数组
    idArr () {
      return this.selectContacts.map((item) => item.id)
    },
    title () {
      switch (this.module) {
        case 'customerApi':
          return '客户'
        case 'contractApi':
          return '合同'
        case 'supplier':
          return '供应商'
        case 'purchase':
          return '采购单'
        case 'contactApi':
          return '联系人'
        case 'opportunityApi':
          return '机会'
        default:
          return '客户'
      }
    }
  },
  methods: {
    // 获取业务模板列表
    getTemplateList () {
      let url = `/${this.module}/templateList.do`
      api.post(url, {}, (data) => {
        this.templateList = data.result
        if (!this.templateList.length) {
          Message(this.module === 'customerApi' ? '对不起,你没有客户模板' : '对不起,你没有合同模板')
          this.dialogVisible = false
          this.$emit('close')
          return
        }
        this.curTemplate = data.result[0] || {}
        if (data.result.length > 3) {
          this.foldTemplate = data.result[2] || {}
          this.foldTemplateList = data.result.filter((item, i) => {
            return i > 1 ? item : false
          })
        }
        // 有模板才获取列表，这里需要加nextTick因为templateList变化是同时变化的，需要有一个顺序
        this.templateList.length && this.$nextTick(() => {
          this.getUserList()
          this.getGroups()
        })
      }, () => {
        this.dialogVisible = false
        this.$emit('close')
      })
    },
    // 切换业务模板
    toggleTemplate (template, type) {
      if (template.key === this.curTemplate.key) {
        return
      }
      if (type !== 'click') {
        this.foldTemplate = template
      }
      this.curTemplate = template
      this.currentPage = 1
      this.getUserList()
      this.getGroups()
    },
    // 选中事件
    handleSelect (selection, row) {
      let selecte = []
      if (!this.multiselect) {
        this.$refs.table.clearSelection()
        if (selection.length) {
          this.$refs.table.toggleRowSelection(row, true)
          selecte = [row]
        } else {
          selecte = []
        }
      } else {
        this.selectArr[this.currentPage] = JSON.parse(JSON.stringify(selection))
        selecte = Array.prototype.concat.apply([], this.selectArr).filter(item => {
          if (item) {
            return item
          }
        })
      }
      this.selectContacts = selecte.map((item) => {
        let obj = {
          id: item.id,
          value: item.value || item.name
        }
        if (item.amount || item.amount === 0) { // 这里存在金额为0的情况，zpp
          obj.amount = item.amount
        }
        if (this.module === 'contractApi') {
          obj.contractNo = item.contractNo
        } else if (this.module === 'customerApi') {
          obj.key = item.type
        }
        if (this.curTemplate && this.curTemplate.key) {
          obj.templateId = this.curTemplate.key
        }
        return obj
      })
    },
    getUserList (query) {
      if (query) {
        this.currentPage = 1
      }
      this.loading = true
      let url = dataMap[this.module]
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        customerId: this.customerId,
        nameLike: query === 'group' ? '' : (query || this.contactSearch),
        belongerType: this.group || '0',
        supplierId: this.supplierId,
        templateId: this.curTemplate.key
      }
      // 根据后端要求联系人接口传refType(做供应商协同时候加的)
      if (this.module === 'contactApi') {
        params.refType = this.moduleName
      }
      // 待采购
      if (this.module === 'supplier' && this.item && this.item.strongAssociation) {
        params.supplierIdIn = this.item.supplierIdIn
      }

      if (this.module === 'purchase' && this.moduleName === 'returnedPurchase') {
        params.fromReturnedPurchase = 1
      }

      // 在新建跟进记录时选择客户，增加该属性，可以拿到公海池的客户
      if (this.fromMoudle === 'communicateApi') {
        params.isPublic = 0
      }
      this.userList = []
      api.post(url, params, (data) => {
        this.loading = false
        this.$nextTick(() => {
          this.userList = data.result
        })
        this.total = data.pageHelper.rowsCount || 0
        this.dialogVisible = true
        this.currentPage = data.pageHelper.currentPageNum || 1
        this.pageSize = data.pageHelper.pageSize || 12
        this.headerArray = data.headerArray
        // checkbox初始化
        this.$nextTick(() => {
          if (this.multiselect) {
            this.selectArr[this.currentPage] = []
          }
          this.userList.forEach((item) => {
            const index = this.idArr.indexOf(item.id)
            if (index > -1) {
              this.$refs.table.toggleRowSelection(item, true)
              if (this.multiselect) {
                this.selectArr[this.currentPage].push(this.selectContacts[index])
                this.selectArr[0] = this.selectArr[0].filter(obj => {
                  if (obj.id !== item.id) {
                    return obj
                  }
                })
              }
            }
          })
        })
      }, () => {
        this.dialogVisible = false
        this.$emit('close')
      })
    },
    getGroups () {
      if (this.module === 'contactApi') {
        return
      }
      let url = dataGroups[this.module]
      let params = {
        child: this.module,
        templateId: this.curTemplate.key
      }
      api.post(url, params, (data) => {
        this.groups = data.groups
        if (this.groups.length > 0) {
          this.group = this.groups[0].key
        }
      })
    },
    // 新建
    addNew () {
      if (this.module === 'purchase') {
        this.$emit('addNew', {module: 'purchase'})
        // 到JXC采购合同新建
        this.$router.push({
          name: 'jxcAddPage',
          query: {
            moduleName: 'purchase',
            id: ''
          },
          params: {
            moduleName: 'purchase',
            id: ''
          }
        })
      } else if (['supplier', 'purchase', 'returnedPurchase'].indexOf(this.moduleName) > -1 && this.module === 'contactApi') {
        this.$emit('addNew', {module: 'supplierContact'})
      } else {
        this.$emit('addNew', {module: this.module, templateId: this.curTemplate.key})
      }
    },
    // 远程搜索
    handleSearch (query) {
      this.currentPage = 1
      query = query.toString().trim()
      window.clearTimeout(lazy)
      lazy = window.setTimeout(() => { this.getUserList(query) }, 500)
    },
    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      this.getUserList()
    },
    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.getUserList()
    },
    // 提交已选数据
    handleSubmit () {
      this.$emit('emitObj', this.selectContacts, this.module)
      this.dialogVisible = false
    }
  },
  watch: {
    dialogVisible () {
      if (this.dialogVisible === false) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style lang="less">
.associated {
  .el-dialog {
    position: fix1ed;
  }
  // 上面不知道为什么要fixed定位，zpp
  .el-dialog--small {
    width: 680px !important;
    background: rgb(72, 87, 106);
  }
  .el-table {
    .el-table__body tr.current-row > td {
      background: #9bbaca;
    }
  }
  .el-dialog__header,
  .el-dialog__footer {
    line-height: 1;
  }
  .el-dialog__body {
    padding: 0;
    padding-left: 10px !important;
    background: #fff;
  }
  .content {
    width: 99%;
    .search {
      padding: 9px;
      .search-left {
        .manager {
          margin: 0;
          margin-right: 20px;
          width: 180px;
          display: inline-block;
          vertical-align: top;
          .el-input {
            .el-input__inner {
              border-width: 0;
              font-size: 15px;
              font-weight: bold;
              font-family: "microsoft Yahei";
            }
          }
        }
        .input {
          width: 160px;
          .el-input__inner {
            border: 1px solid rgb(191, 203, 217);
          }
        }
      }
    }
    .select-list {
      flex: 1;
      .el-table__header {
        .el-checkbox {
          display: none;
        }
      }
    }
    .pagination-wrapper {
      overflow: auto;
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
    }
  }
  .dialog-footer {
    position: relative;
    .select {
      position: absolute;
      left: 200px;
      top: 4px;
      padding: 6px 15px;
      border-radius: 13px;
    }
  }
}
</style>
<style lang="less" scoped>
.associated {
  .search,
  .search-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .select-length {
    line-height: 31px;
    margin-left: 10px;
    letter-spacing: 2px;
  }
  .template {
    color: #060606;
    line-height: 60px;
    position: relative;
    .template-box {
      .template-item {
        display: inline-block;
        position: relative;
        z-index: 1;
        margin-right: 32px;
        height: 45px;
        cursor: pointer;
        outline: none;
        font-size: 12px;
        padding: 0 5px;
        &.active {
          color: #FF9800;
          border-bottom: 2px solid #FF9800;
        }
      }
    }
    &:after {
      content: '';
      width: 100%;
      height: 2px;
      background: #ECEFF6;
      position: absolute;
      bottom: 11px;
      z-index: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// associated-new.vue?79c9901b